import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { getString } from "../../utilities";
import { gtmJoinClick } from "../../utilities/gtm";
import { mobile } from "../../utilities/detection";
import { routeCodes } from "../../config/routes";
import { getLangCode } from "../../config";
import { mpSubCTASelect } from "../../utilities/mixpanel";

export default function AdFree({ doDisplay, path }) {
  const navigate = useNavigate();

  if (doDisplay && !mobile) {
    return (
      <div className="gv-title-buttons-container">
        <button
          type="button"
          className={`button-dimensional-icon adfree ${getLangCode()}`}
          onClick={() => {
            gtmJoinClick(path, "game-button");
            mpSubCTASelect("go ad free", "in content", getString("ads.go"));
            navigate(routeCodes.SUBSCRIBE);
          }}
        >
          <span>{getString("ads.go")}</span>
        </button>
      </div>
    );
  }

  return null;
}

AdFree.propTypes = {
  doDisplay: PropTypes.bool,
  path: PropTypes.string.isRequired,
};
